import React from "react";
import moment from "moment";

//Return PDF for campaign
export const GetPdfHtml = ({ campaign }) => {
  let amountPaid = campaign.pendingAmount
    ? Math.round(campaign.pendingAmount - campaign.totalCost) > 0
      ? Math.round(campaign.pendingAmount - campaign.totalCost)
      : Math.round(campaign.totalCost - campaign.pendingAmount)
    : campaign.totalCost;

  return (
    <div
      id="divToPrint"
      className="pdf_wrapper"
      style={{
        margin: "0px auto",
        display: "none",
        textAlign: "initial",
        width: "780px",
        padding: "30px",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div className="wrapper" style={{ width: "780px" }}>
        {" "}
        <div
          className="pdf_logo"
          style={{ textAlign: "center", marginBottom: "50px" }}
        >
          <img
            src="../../../assets/images/logo_blue.png"
            style={{ width: "80px" }}
          />
        </div>
        <div className="pdf_inner" style={{ marginRight: "60px" }}>
          <h2
            style={{
              color: "#000000",
              fontSize: "20px",
              fontWeight: 900,
              textAlign: "left",
              marginBottom: "30px",
            }}
          >
            Campaign Details
          </h2>
          <div className="camp_detail">
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Campaign Name
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {campaign.name}
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Campaign ID
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {campaign._id}
                </span>
              </div>
            </div>
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Brand Name
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {campaign.brand}
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Product Category
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {campaign.product}
                </span>
              </div>
            </div>
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Package Type
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {campaign.type}
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Days Count
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {campaign.days}
                </span>
              </div>
            </div>
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  Station
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  {campaign.station}
                </span>
              </div>
            </div>
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  Audio Uploaded By
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  {campaign.bigFmAudio ? "User" : "BigFM"}
                </span>
              </div>
            </div>
            { campaign.isMultiDurationAudio == 'true' ? (
              <div style={{marginTop: "1em", marginBottom: "1em"}}>
                <h4 style={{marginTop: "1em", marginBottom: "1em"}}>Selected Multi Duration Audio details</h4>
                <table className="table table-striped" border="1">
                  <thead>
                    <tr>
                      <th>Audio File Name</th>
                      <th>Audio Length</th>
                      <th>Number of Days</th>
                      <th>Rotations per Day</th>
                    </tr>
                  </thead>
                  <tbody>
                  { campaign.multidurationAudioDetail.map((audio) => {
                    return (
                      <tr>
                        <td>{audio.audio}</td>
                        <td>{audio.audioLength} Seconds</td>
                        <td>{audio.numberOfDays}</td>
                        <td>{audio.rotationsPerDay}</td>
                      </tr>
                    );
                  })}
                  </tbody>
                </table>
              </div>
            ):(
              <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    width: "50%",
                    display: "inline-block",
                    float: "left",
                    clear: "both",
                  }}
                >
                  <span
                    style={{
                      color: "rgba(81, 81, 81, 0.8)",
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Audio Duration
                  </span>
                </div>
                <div style={{ width: "50%", display: "inline-block" }}>
                  <span
                    style={{
                      color: "rgba(81, 81, 81, 0.8)",
                      fontSize: "13px",
                      fontWeight: 600,
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    {campaign.audioDuration && campaign.audioDuration.toFixed(0)}{" "}
                    sec
                  </span>
                </div>
              </div>
            )}
            
            { campaign.isMultiDurationAudio != 'true' ? (
              <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    width: "50%",
                    display: "inline-block",
                    float: "left",
                    clear: "both",
                  }}
                >
                  <span
                    style={{
                      color: "rgba(81, 81, 81, 0.8)",
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Audio Length
                  </span>
                </div>
                <div style={{ width: "50%", display: "inline-block" }}>
                  <span
                    style={{
                      color: "rgba(81, 81, 81, 0.8)",
                      fontSize: "13px",
                      fontWeight: 600,
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    {campaign.audioLength} sec
                  </span>
                </div>
              </div>
            ) : '' }
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  Payment Id's
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  {campaign.payId && campaign.payId_1
                    ? `${campaign.payId} , ${campaign.payId_1}`
                    : !campaign.payId_1 && campaign.payId
                    ? campaign.payId
                    : "Not Available"}
                </span>
              </div>
            </div>
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  Time Bands{" "}
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  {campaign.bookingType
                    ? campaign.bookingType
                    : "Not Available"}
                </span>
              </div>
            </div>{" "}
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  Selected Bands{" "}
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  {campaign.timebands ? campaign.timebands : "Not Available"}
                </span>
              </div>
            </div>
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  Sales Representive ID{" "}
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  {campaign.sallerId ? campaign.sallerId : "Not Available"}
                </span>
              </div>
            </div>
            <div className="detail_inner_pdf" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  float: "left",
                  clear: "both",
                }}
              >
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Start Date
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {moment(campaign.startDate).format("DD/MM/YYYY")}
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  What is the objective of your campaign ?
                </span>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 1)",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "block",
                  }}
                >
                  {campaign.objective}
                </span>
              </div>
            </div>
            {/* //vj */}
            <div style={{ width: "50%", display: "inline-block" }}>
              <span
                style={{
                  color: "rgba(81, 81, 81, 0.8)",
                  fontSize: "11px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                Email ID:{" "}
                {campaign.userDetails[0] ? campaign.userDetails[0].email : ""}
              </span>
            </div>
            <div style={{ width: "50%", display: "inline-block" }}>
              <span
                style={{
                  color: "rgba(81, 81, 81, 0.8)",
                  fontSize: "11px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                Client Name:{" "}
                {campaign.userDetails[0] ? campaign.userDetails[0].name : ""}
              </span>
            </div>
            <div style={{ width: "50%", display: "inline-block" }}>
              <span
                style={{
                  color: "rgba(81, 81, 81, 0.8)",
                  fontSize: "11px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                Contact No:{" "}
                {campaign.userDetails[0] ? campaign.userDetails[0].mobile : ""}
              </span>
            </div>
            <div style={{ width: "50%", display: "inline-block" }}>
              <span
                style={{
                  color: "rgba(81, 81, 81, 0.8)",
                  fontSize: "11px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                GST Number:{" "}
                {campaign.kycDetails[0]
                  ? campaign.kycDetails[0].gst_Number
                  : ""}
              </span>
            </div>
            <div style={{ width: "50%", display: "inline-block" }}>
              <span
                style={{
                  color: "rgba(81, 81, 81, 0.8)",
                  fontSize: "11px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                PAN Number:{" "}
                {campaign.kycDetails[0]
                  ? campaign.kycDetails[0].pan_number
                  : ""}
              </span>
            </div>
            <div style={{ width: "50%", display: "inline-block" }}>
              <span
                style={{
                  color: "rgba(81, 81, 81, 0.8)",
                  fontSize: "11px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                GST Address:{" "}
                {campaign.kycDetails[0]
                  ? campaign.kycDetails[0].gst_Address
                  : ""}
              </span>
            </div>
            <div style={{ width: "50%", display: "inline-block" }}>
              <span
                style={{
                  color: "rgba(81, 81, 81, 0.8)",
                  fontSize: "11px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                Billing Address:{" "}
                {campaign.kycDetails[0]
                  ? campaign.kycDetails[0].billing_Address
                  : ""}
              </span>
            </div>
            { campaign.clientKYC && (
              <div style={{ border: "1px solid grey", margin: "2em 0px", padding: "1em" }}>
                <h5>Client KYC</h5>
                <br/>
                <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "11px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Name:{" "}
                  { campaign.clientKYC.name }
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "11px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Email:{" "}
                  { campaign.clientKYC.emailId }
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "11px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  PAN Number:{" "}
                  { campaign.clientKYC.kycdetails.pannumber }
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "11px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  GST:{" "}
                  { campaign.clientKYC.kycdetails.gstnumber }
                </span>
              </div>
              <div style={{ width: "50%", display: "inline-block" }}>
                <span
                  style={{
                    color: "rgba(81, 81, 81, 0.8)",
                    fontSize: "11px",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  Billing Address:{" "}
                  { campaign.clientKYC.kycdetails.billingaddress }
                </span>
              </div>
            </div>
            )
            }
            {/* <div style={{width: '50%', display: 'inline-block'}}>
              <span style={{color: 'rgba(81, 81, 81, 0.8)', fontSize: '11px',
                display: 'block', marginBottom: '10px'}}>UserState:</span>
              <span style={{color: 'rgba(81, 81, 81, 1)', fontSize: '11px',
                  fontWeight: 600, display: 'block'}}>{campaign.userstate}</span>
            </div> */}
          </div>

          <div
            className="campaign_cost"
            style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }}
          >
            <div
              className="camp_cost_inner"
              style={{ padding: "17px 27px", paddingBottom: "0px" }}
            >
              <h6
                style={{
                  fontSize: "15px",
                  fontWeight: 500,
                  color: "#616161",
                  marginBottom: "22px",
                }}
              >
                Campaign Cost
              </h6>
              <ul style={{ paddingLeft: 0 }}>
                {campaign.packageCost !== campaign.actualpackageCost && (
                  <li
                    style={{
                      borderTop: "1px dashed #ddd",
                      color: "#616161",
                      fontSize: "11px",
                      listStyle: "none",
                      lineHeight: 3,
                      clear: "both",
                    }}
                  >
                    <div style={{ float: "left" }}>Actual Package Cost</div>
                    <div style={{ float: "right" }}>
                      <img
                        src="../../../assets/images/rupee-indian.svg"
                        style={{ width: "6px", marginRight: "2px" }}
                      />
                      <span className="cost_inner">
                        {campaign.actualpackageCost}
                      </span>
                    </div>
                  </li>
                )}
                {campaign.couponDiscount > 0 && (
                  <li
                    style={{
                      borderTop: "1px dashed #ddd",
                      color: "#616161",
                      fontSize: "11px",
                      listStyle: "none",
                      lineHeight: 3,
                      clear: "both",
                    }}
                  >
                    <div style={{ float: "left", color: "#15BF4E" }}>
                      Coupon Discount
                      <span
                        style={{
                          color: "#515151",
                          marginTop: "3px",
                          display: "block",
                        }}
                      >
                        Coupon Applied Flat ${campaign.couponPercentage} % OFF
                      </span>
                    </div>
                    <div style={{ float: "right" }}>
                      <img
                        src="../../../assets/images/rupee-indian.svg"
                        style={{ width: "6px", marginRight: "2px" }}
                      />
                      <span className="cost_inner">
                        {campaign.couponDiscount}
                      </span>
                    </div>
                  </li>
                )}
                <li
                  style={{
                    borderTop: "1px dashed #ddd",
                    color: "#616161",
                    fontSize: "11px",
                    listStyle: "none",
                    lineHeight: 3,
                    clear: "both",
                  }}
                >
                  <div style={{ float: "left" }}>Package Cost</div>
                  <div style={{ float: "right" }}>
                    <img
                      src="../../../assets/images/rupee-indian.svg"
                      style={{ width: "6px", marginRight: "2px" }}
                    />
                    <span className="cost_inner">{campaign.packageCost}</span>
                  </div>
                </li>
                <li
                  style={{
                    borderTop: "1px dashed #ddd",
                    color: "#616161",
                    fontSize: "11px",
                    listStyle: "none",
                    lineHeight: 3,
                    clear: "both",
                  }}
                >
                  <div style={{ float: "left" }}>Package Tax@18%</div>
                  <div style={{ float: "right" }}>
                    <img
                      src="../../../assets/images/rupee-indian.svg"
                      style={{ width: "6px", marginRight: "2px" }}
                    />
                    <span className="cost_inner">{campaign.packageTax}</span>
                  </div>
                </li>
                <li
                  style={{
                    borderTop: "1px dashed #ddd",
                    color: "#616161",
                    fontSize: "11px",
                    listStyle: "none",
                    lineHeight: 3,
                    clear: "both",
                  }}
                >
                  <div style={{ float: "left" }}>Audio Cost</div>
                  <div style={{ float: "right" }}>
                    <img
                      src="../../../assets/images/rupee-indian.svg"
                      style={{ width: "6px", marginRight: "2px" }}
                    />
                    <span className="cost_inner">
                      {campaign.audioTotalCost}
                    </span>
                  </div>
                </li>
                <li
                  style={{
                    borderTop: "1px dashed #ddd",
                    color: "#616161",
                    fontSize: "11px",
                    listStyle: "none",
                    lineHeight: 3,
                    clear: "both",
                  }}
                >
                  <div style={{ float: "left" }}>Audio Tax@18%</div>
                  <div style={{ float: "right" }}>
                    <img
                      src="../../../assets/images/rupee-indian.svg"
                      style={{ width: "6px", marginRight: "2px" }}
                    />
                    <span className="cost_inner">{campaign.audioTax}</span>
                  </div>
                </li>
                { parseInt(campaign.nonFCTCodeAmount) > 0 && (
                    <li
                      style={{
                        borderTop: "1px dashed #ddd",
                        color: "#616161",
                        fontSize: "11px",
                        listStyle: "none",
                        lineHeight: 3,
                        clear: "both",
                      }}
                    >
                      <div style={{ float: "left" }}>Non FCT Amount</div>
                      <div style={{ float: "right" }}>
                        <img
                          src="../../../assets/images/rupee-indian.svg"
                          style={{ width: "6px", marginRight: "2px" }}
                        />
                        <span className="cost_inner">
                          {campaign.nonFCTCodeAmount}
                        </span>
                      </div>
                    </li>
                  )}
                {campaign.nonFCTCodeAmountTax &&
                  parseInt(campaign.nonFCTCodeAmount) > 0 && (
                    <li
                      style={{
                        borderTop: "1px dashed #ddd",
                        color: "#616161",
                        fontSize: "11px",
                        listStyle: "none",
                        lineHeight: 3,
                        clear: "both",
                      }}
                    >
                      <div style={{ float: "left" }}>Non FCT Tax@ 18</div>
                      <div style={{ float: "right" }}>
                        <img
                          src="../../../assets/images/rupee-indian.svg"
                          style={{ width: "6px", marginRight: "2px" }}
                        />
                        <span className="cost_inner">
                          {campaign.nonFCTCodeAmountTax}
                        </span>
                      </div>
                    </li>
                  )}

                <li
                  style={{
                    borderTop: "1px dashed #ddd",
                    color: "#616161",
                    fontSize: "11px",
                    listStyle: "none",
                    lineHeight: 3,
                    clear: "both",
                  }}
                >
                  <div style={{ float: "left" }}>Amount Paid</div>
                  <div style={{ float: "right" }}>
                    <img
                      src="../../../assets/images/rupee-indian.svg"
                      style={{ width: "6px", marginRight: "2px" }}
                    />
                    <span className="cost_inner">{amountPaid}</span>
                  </div>
                </li>

                <li
                  style={{
                    borderTop: "1px dashed #ddd",
                    color: "#616161",
                    fontSize: "11px",
                    listStyle: "none",
                    lineHeight: 3,
                    clear: "both",
                  }}
                >
                  <div style={{ float: "left" }}>Pending Amount</div>
                  <div style={{ float: "right" }}>
                    <img
                      src="../../../assets/images/rupee-indian.svg"
                      style={{ width: "6px", marginRight: "2px" }}
                    />
                    <span className="cost_inner">{campaign.pendingAmount}</span>
                  </div>
                </li>
              </ul>
            </div>
            <div
              className="totalcost"
              style={{
                backgroundColor: "#095dab",
                color: "#fff",
                alignItems: "center",
                border: "1px dotted #095dab",
                clear: "both",
                marginTop: "36px",
                height: "40px",
                fontSize: "11px",
                padding: "0px 27px",
                lineHeight: "40px",
              }}
            >
              <div className="campviewlist_type" style={{ float: "left" }}>
                Total Cost
              </div>
              <div
                className="campviewlist_rupee_symb"
                style={{ float: "right" }}
              >
                <img src="../../../assets/images/rupee-indian_white.svg" />
                <span className="cost_inner">{campaign.totalCost}</span>
              </div>
            </div>
          </div>
          <div className="package_include style" style={{ marginTop: "32px" }}>
            <span
              style={{ color: "#0959A3", fontSize: "12px", fontWeight: 500 }}
            >
              Package Includes :
            </span>
            <p />
            <p style={{ color: "#515151", fontSize: "10px" }}>
              {campaign.fctPerDay} Seconds Per Day |{campaign.secondages} Total
              Secondages | {campaign.totalCost} INR | Net Rate per 10secs:{" "}
              {(
                            (campaign.packageCost / campaign.secondages) *
                            10
                          ).toFixed(2)}
              INR Total Cost | {campaign.additionalBenefits} % Additional
              Benefit | {campaign.packageDiscountedCost} INR Discounted Cost
            </p>
            <p />
            {campaign.nonFCT && campaign.nonFCT[0] && (
              <div className="package_include style" >
                <br />
                <span
              style={{ color: "#0959A3", fontSize: "12px", fontWeight: 500 }}
            > NON FCT Addons: </span>
                <p style={{ color: "#515151", fontSize: "10px" }}>{campaign.nonFCT[0].description}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./web/components/common/CampaignPdfHtml.jsx